/* eslint-disable */

import React from 'react';
import { friendBot } from 'AppSrc/core/components/dev-page/friend-bot';
import { PlaygroundRoot } from 'AppSrc/core/components/dev-page/components/playground';
import { AllSvgs } from 'AppSrc/core/components/dev-page/components/all-svgs';

import 'AppSrc/core/components/dev-page/style/dev-page.css';


const consoleBot = () => console.log(friendBot());


const DevPage = React.memo(() => {
  consoleBot();
  return (
    <div id="dev-page">
      <h1
        onClick={consoleBot}
      >🙋‍Welcome Developer</h1>

      <PlaygroundRoot />
      <AllSvgs />
    </div>
  )
});

export { DevPage };
